// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Za9MzZcKIeAno5hzxIEE {
	display: flex;
	justify-content: space-between;
	gap: 16px;
	width: 100%;
}

.B04t2nPyubhUapgVqgan {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.HN51fmQ5njpgrhxefUp3 {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/NameValue/NameValue.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;AACT","sourcesContent":[".root {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tgap: 16px;\n\twidth: 100%;\n}\n\n.name {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 4px;\n}\n\n.value {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Za9MzZcKIeAno5hzxIEE`,
	"name": `B04t2nPyubhUapgVqgan`,
	"value": `HN51fmQ5njpgrhxefUp3`
};
export default ___CSS_LOADER_EXPORT___;
